
export const colours: string[] = [
    'blue', 'brown', 'pink',
    'black', 'green', 'grey',
    'white', 'yellow', 'red',
    'orange', 'purple'
];